import { useEffect, useState } from 'react';
import { useFetch } from './useFetch';
import { useOperator } from '../contexts/OperatorContext';
import { BASE_URL_MAP } from '../lib/environment';
export const useImage = (imageId?: string) => {
  const [image, setImage] = useState<string | undefined>(undefined);
  const { error, makeRequest, response, loading } = useFetch();
  const operator = useOperator();

  useEffect(() => {
    if (imageId) {
      getImage(imageId);
    }
    //eslint-disable-next-line
  }, [imageId]);

  const getImage = (imageId: string) => {
    return makeRequest(
      `${BASE_URL_MAP['Hospitality']}/${operator?.id}/Image/${imageId}`,
      'get',
      null,
      'arraybuffer'
    );
  };

  useEffect(() => {
    if (!loading && response)
      setImage(URL.createObjectURL(new Blob([response])));
  }, [loading, response]);

  return { error, getImage, image, loading };
};
